import styled, { css } from 'styled-components';

export const FilterContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.neutral_100};
      padding: ${theme.spacing.base};
      border-radius: ${theme.radius.sm};
      margin-bottom: ${theme.spacing.base};
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        margin-bottom: ${theme.spacing.md};
      }

      > form {
        display: flex;
        justify-content: space-between;
        align-content: space-between;
        align-items: center;
        gap: 0.5rem;

        > * {
          @media screen and (min-width: ${theme.breakpoint.sm}) {
            max-width: 30%;
            flex-grow: 0;
          }
        }
      }

      > input {
        //width: 100%;
        border: 1px solid ${theme.color.neutral_400};
        border-radius: ${theme.radius.xs};
        font-size: 1rem;
        padding: 0.25rem;
      }
    `;
  }};
`;

export const FilterResult = styled.div<{ fade?: boolean }>`
  ${({ theme, fade, ...props }) => {
    return css`
      display: flex;
      gap: 1rem;
      height: 0;
      visibility: hidden;
      overflow: hidden;
      opacity: 0;
      transition: all 0.2s ease-in-out;

      button {
        color: ${theme.color.secondary_500};
        text-decoration: underline;
      }

      ${fade &&
      css`
        margin: 2rem 0;
        height: auto;
        visibility: visible;
        opacity: 1;
      `};
    `;
  }};
`;
